<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          :config="config"
          @references="references"
        />

        <v-dialog
          v-model="openReference"
          max-width="800px">

          <app-table
            v-if="openReference"
            :config="referenceConfig"
            :hidden-fields="{ storage_id: storage.id }"
            :filters="{ storage_id: storage.id }"
            :subtitle="storage.name"
            modal
            no-search
            hide-upsert
            inline-upsert
            title="Storage center references"
            @close="openReference=false" />

        </v-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import referenceConfig from './config_reference.js'
import { addStorageReference, removeStorageReference } from '@/api/storage'

export default {
  data () {
    return {
      config,
      referenceConfig,
      removeStorageReference,
      addStorageReference,
      openReference: false,
      storage: {}
    }
  },
  methods: {
    references (storage) {
      this.storage = storage
      this.openReference = true
    }
  }
}
</script>
